module.exports = __webpack_public_path__ + "a3dc5ff37d63b5492089baea5797b5dd.MP3";